import DataTableComponent from "./DataTableTestComponent";

export default DataTableComponent;